export default {
    name: "neo-datepicker",
    components: {},
    props: ["placeholder", "label", "value", "margin", "bg", "border", "borderColor", "changeCase", "borderFull", "disabled"],
    data() {
        return {
            focus: false,
        };
    },
    computed: {},
    created() {},
    methods: {},
};
